import type { LinkingOptions } from '@react-navigation/native'

// 웹 URL ↔ 화면 동기화 + 브라우저 히스토리(뒤로/앞으로) 통합.
// - 같은 공용 스크린(PlaceDetail 등)이 세 탭 스택에 모두 존재하므로,
//   URL→화면 역매핑이 유일하도록 탭별 경로 프리픽스를 달리 한다.
// - /auth/kakao/callback 은 여기 매핑하지 않는다 — 콜백 code 는 auth-web.js 가
//   모듈 로드 시점(라우터가 URL 을 바꾸기 전)에 스냅샷으로 읽는다.
// - 한계: PlaceDetail/PlaceEdit/PlaceReport 는 객체 파라미터라 URL 직접 진입
//   (새로고침)으로는 복원되지 않는다. 앱 내 이동·뒤로가기는 정상.
export const linking: LinkingOptions<{}> = {
  prefixes: ['https://go-go.space'],
  config: {
    screens: {
      InitScreen: 'init',
      AuthScreen: 'login',
      BottomTabs: {
        screens: {
          HomeTab: {
            initialRouteName: 'HomeScreen',
            screens: {
              HomeScreen: '',
              SearchScreen: 'search',
              DiscoveryScreen: 'discovery',
              CategorySelectScreen: 'category-select',
              CategoryDiscoveryScreen: 'category',
              PlaceReportScreen: 'report',
              PlaceDetailScreen: 'place',
              PlaceEditScreen: 'place-edit',
              UserDetailScreen: 'user',
              FollowListScreen: 'follows',
              UserMeEditScreen: 'me/edit',
            },
          },
          FeedTab: {
            initialRouteName: 'FeedScreen',
            screens: {
              FeedScreen: 'feed',
              PlaceDetailScreen: 'feed/place',
              PlaceEditScreen: 'feed/place-edit',
              UserDetailScreen: 'feed/user',
              FollowListScreen: 'feed/follows',
              UserMeEditScreen: 'feed/me/edit',
            },
          },
          MyPageTab: {
            initialRouteName: 'UserDetailScreen',
            screens: {
              UserDetailScreen: 'mypage',
              PlaceDetailScreen: 'mypage/place',
              PlaceEditScreen: 'mypage/place-edit',
              FollowListScreen: 'mypage/follows',
              UserMeEditScreen: 'mypage/me/edit',
            },
          },
        },
      },
    },
  },
}
